var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "scroll-board", style: { "--height": _vm.height + "px" } },
    [
      _c(
        "transition-group",
        { attrs: { name: "list" } },
        _vm._l(_vm.viewList, function(item) {
          return _c(
            "div",
            {
              key: item.id,
              staticClass: "row",
              on: {
                mousemove: _vm.mousemove,
                mouseout: _vm.mouseout,
                click: function($event) {
                  return _vm.open(item.href)
                }
              }
            },
            [_vm._t("default", [_vm._v(_vm._s(item))], null, { record: item })],
            2
          )
        }),
        0
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }